var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateGroupDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.1H1V2.9h14v1.2zM3.6 5v8.2c0 .11.09.2.2.2h8.4a.2.2 0 00.2-.2V5h1.2v8.2a1.4 1.4 0 01-1.4 1.4H3.8a1.4 1.4 0 01-1.4-1.4V5h1.2zm3.8 1v5h1.2V6H7.4z",
    fill: "#7D8085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.5l.462-1.849a.2.2 0 01.194-.151h4.688a.2.2 0 01.194.151L11 3.5",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })));
}
export default __webpack_public_path__ + "static/template-group-delete.eff6a45e.svg";
export { SvgTemplateGroupDelete as ReactComponent };